import { render } from "./InfoTags.vue?vue&type=template&id=d22b3d80&scoped=true"
import script from "./InfoTags.vue?vue&type=script&lang=js"
export * from "./InfoTags.vue?vue&type=script&lang=js"

import "./InfoTags.vue?vue&type=style&index=0&id=d22b3d80&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22b3d80"]])

export default __exports__